import { Brain, Flower2, Apple, Sparkles, Stethoscope, Dumbbell, Baby, Heart } from 'lucide-react';

// Tema cromático por especialidad — fuente de verdad: landing/components/sections/ModeloMinutos.tsx.
// Cada especialidad tiene su color de icono y su fondo pastel (tintBg).
// Coral es EXCLUSIVO de Psicología. El resto cae a violeta (One Violet Rule).
//
//  { Icon, iconColor (hex para el glifo), card (clase de fondo pastel de la card) }
const THEMES = {
  gineco: { Icon: Flower2, iconColor: '#786ED9', card: 'bg-brand-tint' },
  psico: { Icon: Brain, iconColor: '#FF8A65', card: 'bg-[#ffe1d6]' },        // coral, exclusivo psicología
  nutri: { Icon: Apple, iconColor: '#52A87C', card: 'bg-mint-pill' },
  salud: { Icon: Stethoscope, iconColor: '#5a4400', card: 'bg-amber-pill/55' }, // icono amber-deep (contraste)
  entren: { Icon: Dumbbell, iconColor: '#3D3580', card: 'bg-brand-soft/40' },
  derma: { Icon: Sparkles, iconColor: '#786ED9', card: 'bg-brand-tint' },
  pediatria: { Icon: Baby, iconColor: '#786ED9', card: 'bg-brand-tint' },
  cardio: { Icon: Heart, iconColor: '#786ED9', card: 'bg-brand-tint' },
};

const DEFAULT_THEME = { Icon: Stethoscope, iconColor: '#786ED9', card: 'bg-brand-tint' };

export function specialtyTheme(name = '') {
  const n = name.toLowerCase();
  if (n.includes('gineco')) return THEMES.gineco;
  if (n.includes('psico') || n.includes('psiqui')) return THEMES.psico;
  if (n.includes('nutri')) return THEMES.nutri;
  if (n.includes('salud') || n.includes('general')) return THEMES.salud;
  if (n.includes('entren')) return THEMES.entren;
  if (n.includes('derma') || n.includes('skin') || n.includes('piel')) return THEMES.derma;
  if (n.includes('pediatr') || n.includes('niñ')) return THEMES.pediatria;
  if (n.includes('cardio') || n.includes('sexual')) return THEMES.cardio;
  return DEFAULT_THEME;
}
